export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2A2A2A] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Col 1 - Brand */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#888888] mb-5 font-semibold">About</p>
            <p className="text-[#AAAAAA] text-sm leading-relaxed">
              Hong Kong-based international commodities trading company serving global markets across metals, minerals, fertilizers, and soft commodities.
            </p>
          </div>

          {/* Col 2 - Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#888888] mb-5 font-semibold">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: 'Company Overview', href: '#overview' },
                { label: 'Vision & Mission', href: '#vision' },
                { label: 'Core Business', href: '#business' },
                { label: 'Product Portfolio', href: '#products' },
                { label: 'Investment', href: '#investment' },
                { label: 'Global Network', href: '#network' },
                { label: 'Sustainability', href: '#sustainability' },
              ].map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNav(link.href)}
                    className="text-[#CCCCCC] text-sm hover:text-[#A0A0A0] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#888888] mb-5 font-semibold">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-[#888888] text-base" />
                </div>
                <div className="text-[#AAAAAA] text-xs leading-relaxed">
                  4/F Lee Gardens Three,<br />1 Sunning Road,<br />Causeway Bay, Hong Kong SAR
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#888888] text-base" />
                </div>
                <a href="tel:+85239606380" rel="nofollow" className="text-[#CCCCCC] text-sm hover:text-[#A0A0A0] transition-colors duration-300 cursor-pointer">
                  +852 3960 6380
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#888888] text-base" />
                </div>
                <a href="mailto:info@bulk-ore.com" rel="nofollow" className="text-[#CCCCCC] text-sm hover:text-[#A0A0A0] transition-colors duration-300 cursor-pointer">
                  info@bulk-ore.com
                </a>
              </div>
              <button
                onClick={() => handleNav('#contact')}
                className="whitespace-nowrap mt-2 w-full py-2.5 border border-[#888888]/50 text-[#A0A0A0] text-xs uppercase tracking-widest rounded-full hover:bg-[#4A4A4A] hover:text-white transition-all duration-300 cursor-pointer font-semibold"
              >
                Get In Touch
              </button>
            </div>
          </div>

          {/* Col 4 - Logo (far right) */}
          <div className="flex items-start justify-end">
            <img
              src="https://public.readdy.ai/ai/img_res/4f1b7e5c-a2f3-4971-ad44-a1a002cdfef9.png"
              alt="Bulk Ore"
              className="h-[70px] w-auto object-contain"
            />
          </div>
        </div>

        {/* Large brand text */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <div className="text-[#888888]/30 font-playfair font-bold text-[clamp(48px,8vw,120px)] tracking-[0.15em] leading-none overflow-hidden select-none text-center">
            BULK ORE
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-[#888888] text-xs">
            &copy; 2026 Bulk Ore Pte. Ltd. All rights reserved. | Hong Kong
          </p>
          <p className="text-[#888888] text-xs">
            International Commodities Trading
          </p>
        </div>
      </div>
    </footer>
  );
}
